import React, { useEffect, useState } from 'react';

import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import GroupSegregationSection from './GroupSegregationSection';

export default function LabelInput({ deleteComponent, rowId, colId, attributes, setAttributes, autoOpen = false, groups = [] }) {
  const [label, setLabel] = useState(attributes ? attributes.label : 'Label');
  // Segregação por grupos
  const [groupIds, setGroupIds] = useState(attributes?.groupIds || []);
  // Edit Modal
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    if (autoOpen) setEditModal(true);
  }, []);

  const submitForm = (e) => {
    e.preventDefault();

    setAttributes({
      rowId,
      colId,
      attributes: {
        label,
        inputName: label,
        ...(groupIds.length > 0 ? { groupIds } : {}),
      },
    });
    setEditModal(false);
  };

  return (
    <div>
      <div className="custom-input-container">
        <Modal
          size="lg"
          isOpen={editModal}
          toggle={() => setEditModal(!editModal)}
          centered
        >
          <ModalHeader toggle={() => setEditModal(false)}>
            Configurar Label
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <Form>
                  <FormGroup className="input-margin-btm">
                    <Label htmlFor="edit-input-text" className="form-label">
                      Digite o texto do label
                    </Label>
                    <Input
                      id="edit-input-text"
                      className="form-control"
                      type="text"
                      placeholder="Digite o texto aqui"
                      value={label}
                      onChange={({ target }) => setLabel(target.value)}
                    />
                  </FormGroup>
                </Form>
                <GroupSegregationSection
                  groups={groups}
                  groupIds={groupIds}
                  onChange={setGroupIds}
                  fieldPrefix={`labelinput-${rowId}-${colId}`}
                />
              </Col>
              <Col style={{borderLeft: '1px solid gray'}}>
                <div style={{ display: 'flex' }}>
                  <Label className="form-label" htmlFor="formText">
                    {label === "Label" ? label : <div dangerouslySetInnerHTML={{__html: label}} />}
                  </Label>
                </div>
              </Col>
            </Row>
            <div className="save-btn-form-container">
              <Button
                color="success"
                className="btn btn-success waves-effect waves-light save-btn-form"
                onClick={(e) => submitForm(e)}
              >
                Salvar
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <div>
          <div className="displayed-config-container">
            <div className="displayed-label">
              <Label className="form-label" htmlFor="formText">
                {label === "Label" ? label : <div dangerouslySetInnerHTML={{__html: label}} />}
              </Label>
            </div>
            <div className="config-form-icon">
              <span
                className="mdi mdi-cog-outline"
                onClick={() => setEditModal(!editModal)}
              />
              <span
                className="mdi mdi-close close-icon"
                title="Remover Campo"
                onClick={() => deleteComponent(rowId, colId)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
